import { Keys, Scene, Vector } from "excalibur";
import HoneyStand from "../actors/honeyStand";
import { gameState, inventoryState, playerState } from "../state/stateManager";
import { goToScene } from "../main";
import {
  checkFirstSale,
  createGainedItem,
  getBrandAwarenessConversion,
  sendAlert,
} from "../utils";
import { Resources } from "../Resources";
import Colin from "../actors/characters/colin";
import { Player } from "../player";
import InventoryHUD from "../ui/inventory";
import sugar from "./../../res/sugar.png";
import BigBen from "../actors/characters/bigBen";
import jar from "./../../res/jar.png";
export default class BigBensCommerce extends Scene {
  constructor() {
    super();

    this.active = 0;
    this.sellHoney = false;
    this.selected = false;
    this.cashout = false;
    const player = new Player(17 * 16, 16 * 16);
    this.player = player;
    this.player.lastDir = "up";
    this.player.wearingVeil = false;
    this.bigBen = new BigBen({ x: 15 * 16, y: 12 * 16 });
    this.bigBen.z = 4;
    this.bigBen.cutScene = true;
    this.player.cutScene = true;
    this.shelfSpace = 200;
    this.jarsToAdd = 0;
    this.offering = 4;
    this.minimum = 100;
    this.accepting = true;
  }
  onActivate(engine) {
    this.inventory = inventoryState.getInventory();
    this.coins = gameState.getCoins();
    Resources.BigBensMap.addToScene(this);
    this.getShelfSpace();
    this.add(this.player);
    this.add(this.bigBen);

    this.menuContainer = document.getElementById("hive-menu-container");
    this.menuContainer.classList.add("commerce");
    this.menuContainer.classList.remove("beeMarketCommerce");
    this.menuContainer.style.display = "flex";
    this.menu = document.getElementById("feed-menu");
    console.log("menu: ", this.menu);
    this.menu.style.display = "block";
    this.drawMenu();
    this.inventoryHUD = new InventoryHUD("bigBensCommerce");
    if (this.shelfSpace < this.minimum) {
      this.accepting = false;
    }
    if (this.inventory.filledJars >= this.minimum) {
      this.jarsToAdd = this.minimum;
    } else {
      this.jarsToAdd = this.inventory.filledJars;
    }
  }
  drawMenu() {
    console.log("inside drawmenu: ", this.active);
    let jarAlert = "";
    if (this.inventory.filledJars < this.minimum) {
      jarAlert = `<h3>You Don't Have Enough Jars</h3>`;
    }
    if (this.active == 0) {
      this.menu.innerHTML = `<h1>Big Ben's</h1>
        <h3>Minimum Jars For Sale: ${this.minimum}</h3>
          ${jarAlert}
        <ul>
            <li id="list0"><span id="selector">></span>Sell Honey</li>
            <li id="list1">Buy Items</li>
          
          </ul>
       
        `;
    } else if (this.active == 1) {
      this.menu.innerHTML = `<h1>Big Ben's</h1>
         <h3>Minimum Jars For Sale: ${this.minimum}</h3>
          ${jarAlert}
        <ul>
            <li id="list0">Sell Honey</li>
            <li id="list1"><span id="selector">></span>Buy Items</li>
          
          </ul>
       
        `;
    }
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.Up)) {
      Resources.Click.play(2);
      if (this.sellHoney) {
        if (this.jarsToAdd + 1 <= this.inventory.filledJars) {
          if (this.jarsToAdd + 1 <= this.shelfSpace) {
            this.jarsToAdd++;
            this.openSellHoneyMenu();
          } else {
            Resources.Error.play(0.5);
            sendAlert("Limited Shelf Space");
          }
        } else {
          Resources.Error.play(0.5);
          sendAlert("Not Enough Jars");
        }
      } else {
        if (this.active == 0) {
          this.active = 1;
        } else {
          this.active = 0;
        }
        this.drawMenu();
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Down)) {
      Resources.Click.play(2);
      if (this.sellHoney) {
        this.jarsToAdd = this.jarsToAdd - 1;
        if (this.jarsToAdd < 0) {
          this.jarsToAdd = 0;
        }
        this.openSellHoneyMenu();
      } else {
        console.log("active : ", this.active);
        if (this.active == 0) {
          this.active = 1;
        } else {
          this.active = 0;
        }
        this.drawMenu();
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Enter)) {
      if (this.active == 0) {
        //restock
        this.selected = true;
        this.sellHoney = true;
        this.openSellHoneyMenu();
      } else if (this.active == 1) {
        //cash out
        this.selected = true;
        this.buyItems = true;
        this.openBuyItemsMenu();
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      if (this.selected) {
        this.drawMenu();
        this.sellHoney = false;
        this.buyItems = false;
        this.selected = false;
      } else {
        this.selected = false;
        this.sellHoney = false;
        this.buyItems = false;
        goToScene("bigBens");
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Space)) {
      console.log(
        "space: selling: ",
        this.sellHoney,
        " cashOut: ",
        this.buyItems
      );
      if (this.sellHoney) {
        if (this.jarsToAdd <= this.shelfSpace) {
          if (this.jarsToAdd >= this.minimum) {
            this.inventory.filledJars =
              this.inventory.filledJars - this.jarsToAdd;

            let con = playerState.getContent();
            con.bigBens.lastSold = new Date().getTime();
            con.brandAwareness = con.brandAwareness + (1 * this.jarsToAdd) / 10;
            playerState.setContent(con);
            let coins = gameState.getCoins();
            coins = coins + parseInt(this.jarsToAdd * this.offering);
            gameState.setCoins(coins);
            inventoryState.setInventory(this.inventory);
            this.inventoryHUD.display();
            Resources.Coins.play();
            checkFirstSale();
            createGainedItem(`$${parseInt(this.jarsToAdd * this.offering)}`);

            this.getShelfSpace();
            this.selected = false;
            this.active = 0;
            this.drawMenu();
          } else {
            Resources.Error.play();
            sendAlert(`Doesn't Meet Minimum`);
          }
        } else {
          Resources.Error.play();
          sendAlert("Limited Shelf Space");
        }
      } else if (this.buyItems) {
        if (this.coins >= 10) {
          let coins = gameState.getCoins();
          this.inventory.sugar = this.inventory.sugar + 10;
          Resources.Coin.play();
          gameState.setCoins(coins - 10);
          createGainedItem("10lbs Sugar");
          inventoryState.setInventory(this.inventory);
          this.inventoryHUD.display();
        }
      }
    }
  }
  onDeactivate() {
    this.menuContainer.style.display = "none";
    this.menu.style.display = "none";
    this.menuContainer.classList.remove("commerce");
    this.inventoryHUD.destroy();
  }
  openBuyItemsMenu() {
    this.menu.innerHTML = `<h1>Big Ben's</h1>
   
    <h3>BUY ITEMS: </h3><p><img src="${sugar}"/> $15</p><p>SPACE> Buy Item</p><p>X> BACK</p>
   
    `;
  }
  openSellHoneyMenu() {
    console.log(
      "inside sellHoneyMenu: inventoryfilled: ",
      this.inventory.filledJars,
      " minimum: ",
      this.minimum
    );
    if (!(this.inventory.filledJars >= this.minimum)) {
      this.menu.innerHTML = `<h1>Big Ben's</h1>
    
        <h3>Shelf Space: ${this.shelfSpace}</h3>
        <h3>Offering $${this.offering} per jar</h3>
        <h1>You Don't Have Enough Jars</h1>
        <h3>Jars To Sell</h3><h3><img class="productImage"src="${jar}"/><span class="iterate">${this.jarsToAdd}</span></h3><p>Use Arrow Keys To Iterate</p><p>Hit Space To Sell</p><p>X> BACK</p>
        
        `;
    } else {
      this.menu.innerHTML = `<h1>Big Ben's</h1>
    
        <h3>Shelf Space: ${this.shelfSpace}</h3>
        <h3>Offering $${this.offering} per jar</h3>
        <h3>Jars To Sell</h3><h3><img class="productImage"src="${jar}"/><span class="iterate">${this.jarsToAdd}</span></h3><p>Use Arrow Keys To Iterate</p><p>Hit Space To Sell</p><p>X> BACK</p>
       
        `;
    }
  }
  getRelationshipConversion(availableJars) {
    let content = playerState.getContent();
    let relationship = content.colin.relationship;
    if (relationship < 10) {
      return availableJars * 0.5;
    } else if (relationship >= 10 && relationship < 20) {
      //mid}
      return availableJars * 0.75;
    } else if (relationship > 20) {
      //full
      return availableJars;
    }
  }
  getTimePassed(unTranslatedTime) {
    let speed = gameState.getGameSpeed();
    let transTime = speed * unTranslatedTime;
    let hours = transTime / 3600000;
    console.log("time passed: ", hours, " hours");
    let totalShelfSpace = 0;
    let totalTime = 72;
    if (hours >= 72) {
      //give full availability
      totalShelfSpace = this.getRelationshipConversion(200);
      totalShelfSpace = getBrandAwarenessConversion(totalShelfSpace);
    } else {
      //fraction availability by time
      let frac = hours / 72;
      totalShelfSpace = this.getRelationshipConversion(200 * frac);
      totalShelfSpace = getBrandAwarenessConversion(totalShelfSpace);
    }
    return totalShelfSpace;
  }
  getShelfSpace() {
    this.content = playerState.getContent();

    if (this.content.bigBens.lastSold == null) {
      //full jar availablility
      this.shelfSpace = 400;
    } else {
      //base jar availability on last sold and relationship with colin and random
      this.shelfSpace = this.getTimePassed(
        new Date().getTime() - this.content.bigBens.lastSold
      );
    }
  }
}
